export default "__VITE_ASSET__DkRx6CvD__"